<script>
	// Stores 
	import { 
		textWhatsappLocacao,
		linkWhatsappLocacao
	 } from '../store.js';  

	// Componentes
	import { link }		from "svelte-routing";
	import PageHeader	from './../components/PageHeader.svelte';

	// Code
	let titlePage = 'Documentação Necessária para Aluguel';    
</script>

<PageHeader title={titlePage}></PageHeader>

<div class="container">
	<p>Confira os requisitos e documentos necessários para alugar um imóvel.</p>
	<hr>

	<div class="box-itens-icon">
		<div class="item" style="min-width: 100%;">
			<div class="icone">
				<i class="fas fa-user fa-5x color-accent fa-fw"></i>
			</div>
			<div class="info">
				<h3>Requisitos Básicos para Inquilino Pessoa Física:</h3>
				<ul class="list-cycle">
					<li>Ficha Cadastral Preenchida e Assinada - <a class="color-accent" href="/fichas-cadastrais">Clique aqui para acessar</a></li>
					<li>Preencher ficha cadastral da administradora com todos os dados;</li>
					<li>Ter no mínimo dois anos de carteira de trabalho assinada no mesmo emprego;</li>
					<li>Não comprometer mais que 30% (trinta porcento) do salário familiar;</li>
					<li>Estar livre e desimpedido de qualquer restrição comercial, judicial ou extra judicial;</li>
					<li>O proeminente locatário poderá compor renda com até três pessoas que vier a morar no imóvel;</li>
					<li>Em caso de locação para estudantes e universitários maior de idade a renda computada será do fiador, e esta deve ser seis vezes maior que o valor do aluguel mais taxas;</li>
					<li>Os imóveis pertencentes aos fiadores e apresentado junto a administradora deverão estar registrados dentro do município de Porto Alegre. Fora do município ou estado a administradora se prontifica a estudar sem compromisso;</li>
					<li>E caso o locatário optar pela modalidade de seguro fiança locatícia o mesmo deve suprir a administradora com toda documentação solicitada pela operadora do seguro;</li>
					<li>Em caso de seguro fiança o proeminente locatário deve encaminhar a documentação junto a imobiliária, cabe a imobiliária escolher qual administradora de seguro utilizara para o processo de fiança, não será aceito seguro encaminhado através de corretores não credenciados a imobiliária;</li>
					<li>Estudamos sem compromisso fiança de empresas ou órgãos públicos;</li>
					<li>Aceitamos titulo de capitalização como forma de fiança. Consulte nosso assessor;</li>
					<li>Aceitamos um fiador com dois imóveis ou dois fiadores cada um com um imóvel;</li>
					<li>Quando o proponente já possuir um aluguel em seu nome, deverá trazer uma carta protocolada pela imobiliária em que o imóvel está locado, declarando que o proponente/locatário, está em dia com os pagamentos de aluguéis e encargos, e que está ciente de que o imóvel será entregue nos próximos 15 dias. Na carta deve constar: Nome completo do locatário, endereço do imóvel, data, carimbo e assinatura do responsável na imobiliária.</li>
				</ul>
			</div>
		</div>
		<div class="item" style="min-width: 100%;">
			<div class="icone">
				<i class="fas fa-user-tie fa-5x color-accent fa-fw"></i>
			</div>
			<div class="info">
				<h3>Requisitos Básicos para Inquilino Pessoa Jurídica:</h3>
				<ul class="list-cycle">
					<li>Ficha Cadastral Preenchida e Assinada - <a class="color-accent" href="/fichas-cadastrais">Clique aqui para acessar</a></li>
					<li>Estar livre e desimpedido de qualquer restrição comercial, judicial ou extra judicial;</li>
					<li>O proeminente locatário poderá compor renda com até três pessoas desde que as mesmas façam parte sociedade;</li>
					<li>Negativa de protestos de todos cartórios;</li>
					<li>Negativa do fórum civil e criminal;</li>
					<li><b>Observações: </b>Todas as cópias deverão vir acompanhadas dos documentos originais;<br/>Quando o proponente já possuir um aluguel em seu nome, deverá trazer uma carta protocolada pela imobiliária em que o imóvel está locado, declarando que o proponente/locatário, está em dia com os pagamentos de aluguéis e encargos, e que está ciente de que o imóvel será entregue nos próximos 15 dias. Na carta deve constar: Nome completo do locatário, endereço do imóvel, data, carimbo e assinatura do responsável na imobiliária.</li>
				</ul>
			</div>
		</div>
		<div class="item" style="min-width: 100%;">
			<div class="icone">
				<i class="fas fa-user-shield fa-5x color-accent fa-fw"></i>
			</div>
			<div class="info">
				<h3>Requisitos Básicos para Fiador:</h3>
				<ul class="list-cycle">
					<li>Ficha Cadastral Preenchida e Assinada - <a class="color-accent" href="/fichas-cadastrais">Clique aqui para acessar</a></li>
					<li>Ter no mínimo dois anos de carteira de trabalho assinada no mesmo emprego;</li>
					<li>Não comprometer mais que 30% (trinta porcento) do salário familiar;</li>
					<li>Estar livre e desimpedido de qualquer restrição comercial, judicial ou extra judicial;</li>
					<li>Os imóveis pertencentes aos fiadores e apresentado junto a administradora deverão estar registrados dentro do município de Porto Alegre;</li>
					<li>Estudamos sem compromisso imóveis fora da praça de Porto Alegre;</li>
					<li>Estudamos sem compromisso fiança de empresas ou órgãos públicos;</li>
					<li>Aceitamos um fiador com dois imóveis ou dois fiadores cada um com um imóvel;</li>
					<li>Não será aceito fiadores que já estiverem afiançando outro imóvel, caso o fiador tiver dado fiança em outro imóvel, devera trazer da imobiliária ou administradora carta de anuência e encerramento do contrato, declarando que o mesmo não mais tem qualquer compromisso com o contrato anterior;</li>
					<li>Não será aceito cópia de escritura, contrato de compra e venda, partilha não registrada e carta de adjucação não registrada;</li>
					<li><b>Obrigatório: </b>O fiador deve apresentar cópia da matricula dos imóveis, atualizada (matricula com ônus), esta emitida pelo Registro de Imóveis.</li>
				</ul>
			</div>
		</div>
		<div class="item" style="min-width: 100%;">
			<div class="info">
				<h2>Documentação de acordo com o perfil:</h2>
			</div>
		</div>
		<div class="item">
			<div class="icone">
				<i class="fas fa-users fa-5x color-accent fa-fw"></i>
			</div>
			<div class="info">
				<h3>Empregados em Geral:</h3>
				<ul class="list-cycle">
					<li>Cópia da carteira de identidade (frente e verso);</li>
					<li>Cópia do CPF (frente e verso);</li>
					<li>Cópia dos 3 (três) últimos comprovantes de renda; olerite, extrato bancário, declaração de imposto de renda;</li>
					<li>Cópia do comprovante de residência; conta luz, água, telefone fixo;</li>
					<li>Cópia da CTPS: das páginas da foto e verso da mesma, do contrato de trabalho, e das últimas alterações salariais;
					<li>No caso de troca de emprego por aumento de salário, deverá ser solicitado cópia do último registro de emprego;</li>
					<li>No caso de estagiário/bolsista, deverá ser apresentada a declaração da instituição, informando o período do estágio e comprovantes de crédito do valor referente à bolsa auxílio;</li>
					<li>Cópia do último extrato de fundo de garantia;</li>
					<li>Ficha cadastral devidamente preenchida e assinada pelas partes.</li>
				</ul>
			</div>
		</div>
		<div class="item">
			<div class="icone">
				<i class="fas fa-id-card-alt fa-5x color-accent fa-fw"></i>
			</div>
			<div class="info">
				<h3>Funcionário Público:</h3>
				<ul class="list-cycle">
					<li>Cópia da carteira de identidade (frente e verso);</li>
					<li>Cópia do CPF (frente e verso);</li>
					<li>Cópia dos 3 (três) últimos contra-cheques; </li>
					<li>Comprovante de residência;</li>
					<li>Nomeação;</li>
					<li>Carteira ou crachá da instituição para a qual trabalha, onde conste a data do início das atividades.</li>
				</ul>
			</div>
		</div>
		<div class="item">
			<div class="icone">
				<i class="fas fa-user-chart fa-5x color-accent fa-fw"></i>
			</div>
			<div class="info">
				<h3>Comissionado (Renda Variável):</h3>
				<ul class="list-cycle">
					<li>Cópia da carteira de identidade (frente e verso);</li>
					<li>Cópia do CPF (frente e verso);</li>
					<li>Cópia dos 6 (seis) últimos contra-cheques;</li>
					<li>Comprovante de residência;</li>
					<li>Cópia da CTPS, comprovando vínculo, com últimas alterações salariais;</li>
					<li>Cópia da Declaração de Imposto de Renda Pessoa Física completa com formulário de entrega carimbado (obrigatório).</li>
				</ul>
			</div>
		</div>
		<div class="item">
			<div class="icone">
				<i class="fas fa-clipboard-user fa-5x color-accent fa-fw"></i>
			</div>
			<div class="info">
				<h3>Funcionário Público Aposentado:</h3>
				<ul class="list-cycle">
					<li>Cópia da carteira de identidade (frente e verso);</li>
					<li>Cópia do CPF (frente e verso);</li>
					<li>Comprovante de residência;</li>
					<li>Cópia dos 3 (três) últimos contra-cheques.</li>
				</ul>
			</div>
		</div>
		<div class="item">
			<div class="icone">
				<i class="fas fa-portrait fa-5x color-accent fa-fw"></i>
			</div>
			<div class="info">
				<h3>Aposentado do INSS:</h3>
				<ul class="list-cycle">
					<li>Cópia da Carteira de identidade (frente e verso);</li>
					<li>Cópia do CPF (frente e verso);</li>
					<li>Comprovante de residência;</li>
					<li>Cópia do cartão do banco onde saca o benefício;</li>
					<li>Cópia dos três últimos saques;</li>
					<li>Cópia do último extrato trimestral.</li>
				</ul>
			</div>
		</div>
		<div class="item">
			<div class="icone">
				<i class="fas fa-briefcase fa-5x color-accent fa-fw"></i>
			</div>
			<div class="info">
				<h3>Autônomos e Profissionais Liberais:</h3>
				<ul class="list-cycle">
					<li>Cópia da Carteira de identidade (frente e verso);</li>
					<li>Cópia do CPF (frente e verso);</li>
					<li>Cópia do comprovante de residência;</li>
					<li>Cópia da declaração de IR Pessoa Física completa com formulário de entrega carimbado (obrigatório);</li>
					<li>Cópia do Contrato de Prestação de Serviços, Alvará de Localização, inscrição na Prefeitura e cópia de DARF's de pagamentos de impostos (IR, COFINS ou PIS);</li>
					<li>Cópia da carteira profissional onde conste data de matrícula no órgão de classe;</li>
					<li>DECORE dos 3(três) últimos meses, elaborada por contador com etiqueta fornecida pelo Conselho Regional de Contabilidade.</li>
				</ul>
			</div>
		</div>
		<div class="item">
			<div class="icone">
				<i class="fas fa-user-tie fa-5x color-accent fa-fw"></i>
			</div>
			<div class="info">
				<h3>Empresários e Microempresários:</h3>
				<ul class="list-cycle">
					<li>Cópia da Carteira de identidade (frente e verso);</li>
					<li>Cópia do CPF (frente e verso);</li>
					<li>DECORE dos 3(três) últimos meses, elaborada por contador com etiqueta fornecida pelo Conselho Regional de Contabilidade;</li>
					<li>Cópia do comprovante de residência;</li>
					<li>Cópia da declaração de IR Pessoa Física completa com formulário de entrega carimbado (obrigatório);</li>
					<li>Cópia do Contrato Social da Empresa;</li>
					<li>Cópia do cartão do CNPJ atualizado;</li>
					<li>Cópia da declaração de IR Pessoa Jurídica do último exercício completa com formulário de entrega carimbado (obrigatório);</li>
					<li>Cópia dos 3 (três) últimos DARF's de recolhimento de impostos (SIMPLES, COFINS ou PIS);</li>
					<li>Relação de faturamento mensal do último exercício e do exercício atual, devidamente assinadas pelo contador e por representante legal da empresa, em papel timbrado e com firma reconhecidas.</li>
				</ul>
			</div>
		</div>
		<div class="item">
			<div class="icone">
				<i class="fas fa-store-alt fa-5x color-accent fa-fw"></i>
			</div>
			<div class="info">
				<h3>Empresa de Porte Pequeno:</h3>
				<ul class="list-cycle">
					<li>Cópia da carteira de identidade dos sócios (frente e verso);</li>
					<li>Cópia do CPF dos sócios (frente e verso);</li>
					<li>Comprovante de residência dos sócios;</li>
					<li>Cópia Contrato Social e posteriores alterações contratuais, principalmente as que constem o último aumento de capital a quem assina pela empresa;</li>
					<li>Cópia da declaração de IR Pessoa Jurídica do último exercício completa com formulário de entrega carimbado (obrigatório);</li>
					<li>Cópia do DARF's de pagamentos de impostos (SIMPLES, COFINS ou PIS) dos 3 (três) últimos meses;</li>
					<li>Cópia do cartão de CNPJ;</li>
					<li>Relação de faturamento mensal do último exercício atual, devidamente assinadas pelo contador e por representante legal da empresa, em papel timbrado e com firmas reconhecidas.</li>
				</ul>
			</div>
		</div>
		<div class="item">
			<div class="icone">
				<i class="fas fa-building fa-5x color-accent fa-fw"></i>
			</div>
			<div class="info">
				<h3>Empresa de Médio e Grande Porte:</h3>
				<ul class="list-cycle">
					<li>Cópia da carteira de identidade dos sócios (frente e verso);</li>
					<li>Cópia do CPF dos sócios (frente e verso);</li>
					<li>Comprovante de residência dos sócios;</li>
					<li>Cópia do Contrato Social e posteriores alterações contratuais, principalmente as que constem o último aumento de capital e quem assina pela empresa;</li>
					<li>Cópia do cartão de CNPJ;</li>
					<li>Cópia dos 3 (três) últimos balanços patrimoniais e do balancete recente, com assinatura do contador e responsável pela empresa;</li>
					<li>Cópia da declaração de IR Pessoa Jurídica do último exercício completa, com formulário de entrega carimbado (obrigatório);</li>
					<li>Cópia de DARF's de pagamentos de impostos (SIMPLES, COFINS ou PIS) dos 3 (três) últimos meses.</li>
				</ul>
			</div>
		</div>
	</div>
	<br />
	<p>Em caso de dúvidas, entre em <a href="/contato">contato</a> conosco, nossa equipe está à disposição para auxiliar.</p>
	<div class="button text-center mt-40">
		<a href="/garantias-locaticias" use:link replace title="Confira as garantias locatícias" class="btn btn-primary">Confira as garantias locatícias <i class="far fa-arrow-right"></i></a>
	</div>
	<br />

</div>